import { render, staticRenderFns } from "./Profit.vue?vue&type=template&id=5987bc9c&"
import script from "./Profit.vue?vue&type=script&lang=ts&"
export * from "./Profit.vue?vue&type=script&lang=ts&"
import style0 from "./Profit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports